// The Japan Unfolded mark (the owner's logo of 2026-10-05): a sensu fan of seven red
// blades with paper gaps, the torii standing on the rivet. One geometry for the logo
// and the thinking animation (Japan-Unfolded-Animaciones.html, "Pliegue hacia la
// izquierda"); the PNG icons are drawn from it by scripts/brand/draw_icons.py.

const RED = "#E82529";
const INK = "#1E1A15";

const point = (radius, degrees) => {
  const angle = (degrees * Math.PI) / 180;
  return [(100 + radius * Math.cos(angle)).toFixed(1), (150 + radius * Math.sin(angle)).toFixed(1)];
};
const [x0, y0] = point(100, -98.4);
const [x1, y1] = point(100, -81.6);
const BLADE = `M100,150 L${x0},${y0} A100 100 0 0 1 ${x1},${y1} Z`;
const BASES = Array.from({ length: 7 }, (_, i) => -60 + i * 20);

const Torii = ({ color }) => (
  <g fill={color}>
    <rect x="56" y="86" width="88" height="12" rx="2" />
    <rect x="66" y="108" width="68" height="8" rx="2" />
    <rect x="72" y="98" width="10" height="52" />
    <rect x="118" y="98" width="10" height="52" />
    <circle cx="100" cy="150" r="9" />
  </g>
);

/** The mark alone. The torii takes the page's text colour: ink on paper, white at night. */
export const FanMark = ({ size = 24, toriiColor = "var(--zen-text)", title = "Japan Unfolded", style }) => (
  <svg width={size * (192 / 116)} height={size} viewBox="4 44 192 116" role="img" aria-label={title}
       style={{ display: "block", flex: "none", ...style }}>
    {BASES.map((base) => <path key={base} d={BLADE} fill={RED} transform={`rotate(${base} 100 150)`} />)}
    <Torii color={toriiColor} />
  </svg>
);

/** JAPAN UN·FOLDED, the wordmark beside the mark. */
export const Wordmark = ({ size = 12 }) => (
  <span style={{ fontFamily: '"Unbounded", sans-serif', fontWeight: 900, fontSize: size, letterSpacing: "0.04em",
                 textTransform: "uppercase", color: "var(--zen-text)", whiteSpace: "nowrap" }}>
    JAPAN&nbsp;UN·<span style={{ color: RED }}>FOLDED</span>
  </span>
);

const FOLD_SECONDS = 7.2;   // the study's 3.6 s at the owner's chosen speed, 0.5×

const foldFrames = BASES.map((_, i) => {
  const closed = -i * 20;
  const openStart = 12 + i * 5, openEnd = openStart + 11;
  const closeStart = 62 + (6 - i) * 3, closeEnd = closeStart + 10;
  return `@keyframes ju-fold-${i} { 0%,${openStart}% { transform:rotate(${closed}deg); } ${openEnd}%,${closeStart}% { transform:rotate(0deg); } ${closeEnd}%,100% { transform:rotate(${closed}deg); } }`;
}).join("\n");

const LOADER_CSS = `${foldFrames}
.ju-loader .ju-blade { transform-box: view-box; transform-origin: 100px 150px;
  animation-duration: ${FOLD_SECONDS}s; animation-timing-function: cubic-bezier(.55,0,.32,1); animation-iteration-count: infinite; }
@media (prefers-reduced-motion: reduce) { .ju-loader .ju-blade { animation: none !important; transform: none !important; } }`;

/** The thinking animation: the fan opens to the right and folds back to the left,
 *  its first blade fixed as the hinge. Used on both waits (selection and trip). */
export const FanLoader = ({ size = 112 }) => (
  <div className="ju-loader" role="img" aria-label="Japan Unfolded is thinking"
       style={{ width: size, height: size, borderRadius: size * 0.223, background: RED, overflow: "hidden", flex: "none", margin: "0 auto" }}>
    <style>{LOADER_CSS}</style>
    <svg viewBox="0 0 200 200" width={size} height={size} aria-hidden="true" style={{ display: "block" }}>
      <g transform="translate(100 100) scale(.6) translate(-100 -104.5)">
        {BASES.map((base, i) => (
          <g key={base} transform={`rotate(${base} 100 150)`}>
            <path className="ju-blade" d={BLADE} fill="#F5F5F0" style={{ animationName: `ju-fold-${i}` }} />
          </g>
        ))}
        <Torii color={INK} />
      </g>
    </svg>
  </div>
);

export default FanMark;
